import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorShippingHeaderCancel = () => {
  const { t } = useTranslation()
  const correctionHeaderCancel = useCallback(
    (payload) => {
      const uidTransaction = payload.transaction_uid
      delete payload.transaction_uid
      ApiService.jsonRequest('/transaction-shipping-header/cancel', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t('response_message.shipping_cancelled_success'),
            timer: 2000,
            redirect: `/order/shipping?uid=${uidTransaction}`,
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t('response_message.shipping_cancelled_failed'),
            timer: 2000,
            redirect: `/order/shipping?uid=${uidTransaction}`,
          })
        }
      })
    },
    [t],
  )
  return { correctionHeaderCancel }
}

export default InteractorShippingHeaderCancel
